import angular from 'angular';

(global => {
  class Redis {
    constructor($log, $http, Endpoints) {
      'ngInject';

      Object.assign(this, {
        $log,
        $http,
        Endpoints
      });
    }

    getRedisCache(role) {
      return this.$http.post(this.Endpoints.redis.base, {
        roles: role
      });
    }

    getKey(key) {
      return this.$http.post(this.Endpoints.redis.key.replace(':key', key), {
        loadingText: 'Loading Cache',
        cache: false
      });
    }

    flushKey(key) {
      return this.$http.delete(this.Endpoints.redis.key.replace(':key', key));
    }

  }

  Redis.$inject = ["$log", "$http", "Endpoints"];
  angular.module('pims').service('Redis', Redis);
  global.Redis = Redis;
})(window);